import {
    TableCell,
    TableRow,
    Stack,
    Typography,
    ButtonGroup,
    IconButton,
    Menu,
    MenuItem,
    Divider,
} from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import Iconify from 'src/components/iconify';
import { useTranslation } from 'react-i18next';
import { FormatNumber, glb_sv } from 'src/utils';
import Label from 'src/components/label';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ToolTipCustomTakeDevice from '../list-take-device/modal/ToolTipCustomTakeDevice';

const ItemListReviewDevice = ({
    item,
    index,
    STATUS_COLOR,
    isAdmin,
    dataRef,
    openButton,
    setVisibleOpenAdminGet,
    setVisibleOpenAdminReview,
}) => {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState(null);
    const [openEdit, setOpenEdit] = useState(false);
    const anchorTabEdit = useRef(null);
    const user = glb_sv.userInfo;
    return (
        <TableRow hover key={index} tabIndex={-1} role="checkbox">
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox"></TableCell>
            <TableCell padding="checkbox">{index + 1}</TableCell>
            <TableCell
                align="left"
                onClick={(e) => {
                    if (['5', '6'].includes(item.status)) {
                        setAnchorEl(e.currentTarget);
                    }
                }}
            >
                <Label color={STATUS_COLOR[item.status]}>
                    {item?.bussiness == 'igb' && !['8', '9'].includes(item.status)
                        ? item.key_mean
                        : item?.status == '4'
                        ? t('have_refund')
                        : item.status_content}
                </Label>
            </TableCell>

            <TableCell
                align="left"
                style={{ minWidth: '250px' }}
                onClick={(e) => {
                    if (['5', '6'].includes(item.status)) {
                        setAnchorEl(e.currentTarget);
                    }
                }}
            >
                <Stack direction="row" alignItems="center" spacing={2}>
                    {openButton && (
                        <img
                            style={{
                                width: '50px',
                                height: '50px',
                                borderRadius: '5px',
                                backgroundColor: '#999',
                            }}
                            src={`${glb_sv.urlGetProductImage(item?.img_device || item?.pic_device)}`}
                            alt=""
                        />
                    )}
                    <Typography variant="subtitle2">{glb_sv.convertMultipleLanguages(item.device_nm)}</Typography>
                </Stack>
            </TableCell>
            {/* <TableCell align="left">{item.device_cd}</TableCell> */}
            <TableCell align="left">
                <Stack display={'flex'} flexDirection={'column'}>
                    <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                        {t('cabinet')}: {item.cabinet_nm}
                    </Typography>
                    <Typography variant="subtitle3" noWrap>
                        {t('drawer')}: {item.drawer_nm}
                    </Typography>{' '}
                    <Typography variant="subtitle3" noWrap>
                        {t('cell')}: {`[ ${item?.cell_lc?.row} : ${item?.cell_lc?.column} ]`}
                    </Typography>
                </Stack>
            </TableCell>

            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.user_nm}
                </Typography>
            </TableCell>
            <TableCell>{item.user_return_date && glb_sv.formatDate(item.user_return_date, 'YYYYMMDDHHmmss')}</TableCell>
            <TableCell align="right" sx={{ fontWeight: '600' }}>
                {item.qty} Pcs
            </TableCell>
            <TableCell align="right">
                <Typography variant="subtitle2">{item.qty_change_request} Pcs</Typography>
            </TableCell>
            <TableCell align="right">
                <Typography
                    variant="subtitle2"
                    color={item.cell_qty + item.qty < item.qty_change_request ? 'error' : 'primary'}
                >
                    {item.cell_qty} Pcs
                </Typography>
            </TableCell>
            <TableCell align="right">
                <Typography variant="subtitle2">{item.note_change}</Typography>
            </TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {item.request_user_nm}
                </Typography>
            </TableCell>
            <TableCell align="left">
                {item.request_date && glb_sv.formatDate(item.request_date, 'YYYYMMDDHHmmss')}
            </TableCell>
            <TableCell>
                <Typography variant="subtitle2" noWrap color="primary">
                    {['5', '6', '7'].includes(item.status) ? item?.user_approve_grindding_nm : item.user_approve_nm}
                </Typography>
            </TableCell>
            <TableCell align="left">
                {['5', '6', '7'].includes(item.status)
                    ? item.approve_grindding_or_reject_date &&
                      glb_sv.formatDate(item.approve_grindding_or_reject_date, 'YYYYMMDDHHmmss')
                    : item.approve_or_reject_date && glb_sv.formatDate(item.approve_or_reject_date, 'YYYYMMDDHHmmss')}
            </TableCell>
            <TableCell align="left">{item.reason}</TableCell>
            <TableCell align="left">{item.note_repair_device}</TableCell>
            <TableCell align="left">
                {parseInt(item.status) >= 5 && parseInt(item.status) < 8 && (
                    <Stack display={'flex'} flexDirection={'column'}>
                        <Typography variant="subtitle3" noWrap sx={{ fontWeight: '600' }}>
                            {t('cabinet')}: {item.cabinet_admin_put_cabinet_nm}
                        </Typography>{' '}
                        <Typography variant="subtitle3" noWrap>
                            {t('drawer')}: {item.drawer_admin_put_drawer_nm}
                        </Typography>{' '}
                        <Typography variant="subtitle3" noWrap>
                            {t('cell')}:{' '}
                            {`[ ${item?.cell_admin_put_cell_lc?.row} : ${item?.cell_admin_put_cell_lc?.column} ]`}
                        </Typography>
                    </Stack>
                )}
            </TableCell>
            <TableCell align="left">{item.note}</TableCell>

            <TableCell align="left">{item?.depreciation_rate ? FormatNumber(item?.real_price_transaction) :FormatNumber(item?.price_transaction) }</TableCell>
            <TableCell align="left">
                {!item?.depreciation_rate || item?.depreciation_rate == '' ? '' : item.depreciation_rate + ' %'}
            </TableCell>
            <TableCell align="left">{item?.depreciation_rate ? FormatNumber(item?.price_transaction) :FormatNumber(item?.real_price_transaction)}</TableCell>
            <TableCell align="left">{FormatNumber(item?.price_after_depreciation)}</TableCell>

            <TableCell align="left">
                <Typography variant="subtitle2" noWrap color="primary">
                    {item?.device_cd}
                </Typography>
            </TableCell>

            {openButton && (
                <TableCell
                    padding="checkbox"
                    sx={{
                        position: 'sticky',
                        right: 0,
                        backgroundColor: 'white',
                        zIndex: 3,
                        backgroundColor: '#f4f6f8',
                    }}
                    ref={anchorTabEdit}
                >
                    <IconButton
                        size="large"
                        // color={'success'}
                        onClick={() => {
                            setOpenEdit(true);
                        }}
                    >
                        <MoreHorizIcon />
                    </IconButton>

                    <Menu
                        anchorEl={anchorTabEdit.current}
                        open={Boolean(anchorTabEdit.current) && openEdit}
                        onClose={() => setOpenEdit(false)}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                    >
                        <MenuItem
                            size="large"
                            disabled={item.id_admin_check_depreciation}
                            onClick={() => {
                                dataRef.current = item;
                                setVisibleOpenAdminGet(true);
                            }}
                        >
                            <IconButton
                                disabled={item.id_admin_check_depreciation}
                                color={'primary'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Iconify icon={'mdi:package-variant-remove'} />{' '}
                                <Typography style={{ marginLeft: 10 }}>{t('lay_tb')}</Typography>
                            </IconButton>
                        </MenuItem>
                        <Divider sx={{ my: 0.5 }} />
                        <MenuItem
                            size="large"
                            onClick={() => {
                                dataRef.current = item;
                                setVisibleOpenAdminReview(true);
                            }}
                            disabled={!item.id_admin_check_depreciation || item.id_admin_put_and_check_depreciation}
                        >
                            <IconButton
                                disabled={!item.id_admin_check_depreciation || item.id_admin_put_and_check_depreciation}
                                color={'warning'}
                                disableRipple
                                style={{
                                    padding: 0,
                                    margin: 0,
                                }}
                            >
                                <Iconify icon={'mdi:clipboard-check-outline'} />
                                <Typography style={{ marginLeft: 10 }}>{t('review_return_device')}</Typography>
                            </IconButton>
                        </MenuItem>
                    </Menu>
                </TableCell>
            )}
            {/* <TableCell padding="checkbox"></TableCell> */}
            <ToolTipCustomTakeDevice open={anchorEl} handleClose={() => setAnchorEl(null)} item={item} />
        </TableRow>
    );
};

export default ItemListReviewDevice;
